import { GripVertical, Trash } from "lucide-react";
import { CSS } from "@dnd-kit/utilities";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { PhotoWorkflow } from "@/models/photo-workflow.model";
import { useSortable } from "@dnd-kit/sortable";

interface SortableCardProps {
  item: PhotoWorkflow;
  handleDelete: () => void;
}

export default function SortableCard({ item, handleDelete }: SortableCardProps) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Card ref={setNodeRef} style={style} className="mb-4 w-full select-none">
      <CardHeader className="flex flex-row items-center justify-between">
        <div className="flex items-center gap-2">
          {/* 👇 Only attach drag listeners here */}
          <GripVertical className="cursor-move" strokeWidth={1} {...attributes} {...listeners} />
          <div>
            <CardTitle className="text-base">{item.title}</CardTitle>
            <CardDescription>{item.description}</CardDescription>
          </div>
        </div>

        <Button variant="destructive" size="sm" onClick={handleDelete}>
          <Trash className="w-4 h-4" />
        </Button>
      </CardHeader>
    </Card>
  );
}
